import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Modal, ModalFooter } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
function ERPGatewayModal({ onConfirm, onClose, open, header, body, confirmButtonText, consfirmButtonDisabled = false, showCancel }) {
    useTranslation();
    const confirmHandler = () => {
        onClose();
        onConfirm();
    };
    const modalFooter = () => (_jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [showCancel && (_jsx(Button, { variant: "outlined", onClick: onClose, children: $t('Cancel') })), _jsx(Button, { onClick: confirmHandler, disabled: consfirmButtonDisabled, children: confirmButtonText })] }) }));
    return (_jsx(Modal, { size: "sm", open: open, modalHeader: header, modalFooter: modalFooter(), onClose: onClose, children: body }));
}
ERPGatewayModal.defaultProps = {
    showCancel: true
};
export default ERPGatewayModal;
